import { useHandler } from "@redotech/react-util/hook";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { SettingsPermissions } from "@redotech/redo-model/permissions";
import { FlowType } from "@redotech/redo-model/return-flow";
import { ManualReviewState } from "@redotech/redo-return-ui/flows/return-flow/manual-review";
import {
  StepId,
  StepTypeDetailsProps,
} from "@redotech/redo-return-ui/flows/step";
import { RedoTextareaInputField } from "@redotech/redo-web/arbiter-components/input/redo-textarea-input-field";
import { Divider } from "@redotech/redo-web/divider";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const ManualReviewDetails = memo(function ManualReviewDetails({
  stepSelect,
  state,
  setState,
  flowType,
}: StepTypeDetailsProps<ManualReviewState>) {
  const canEditReturnsSettings = useHasPermission(
    SettingsPermissions.SET_RETURNS_AND_CLAIMS_SETTINGS,
  );
  const nextStepChange = useHandler((next: StepId | undefined) => {
    setState((state) => ({ ...state, next }));
  });
  const handleReason = useHandler((reason: string) => {
    setState((state) => ({ ...state, reason }));
  });

  return (
    <>
      <Flex dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          Reason
        </Text>
        <RedoTextareaInputField
          placeholder="Enter reason for manual review..."
          readOnly={!canEditReturnsSettings}
          setValue={handleReason}
          value={state.reason}
        />
        <Text fontSize="xxs" fontWeight="regular" textColor="tertiary">
          A description of why this return is being marked for manual review.
        </Text>
      </Flex>
      <Divider />
      <Flex dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          Next step
        </Text>
        {stepSelect({ value: state.next, valueChange: nextStepChange })}
        {flowType !== FlowType.FINALIZE_RETURN &&
          flowType !== FlowType.FINALIZE_CLAIM &&
          !state.next && (
            <Text fontSize="xs" textColor="error">
              Required
            </Text>
          )}
      </Flex>
    </>
  );
});
